export enum CustomerType {
	B2c = "B2c",
	B2b = "B2b",
}
